import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CommonState {
  token: string;
  previousRoute: string;
  userDetails: Record<string, any>;
  isLoggedIn: boolean;
  isLoading: boolean;
  progress: number;
  activeCustomerTab: string;
  wishListCount: number;
  header: Record<string, any>;
  themeJson: Record<string, any>;
  templateImages: Record<string, any>;
}

const initialState: CommonState = {
  header: {},
  wishListCount: 0,
  activeCustomerTab: 'welcome',
  token: '',
  previousRoute: '/',
  userDetails: {},
  isLoggedIn: false,
  isLoading: false,
  progress: 0,
  themeJson: {},
  templateImages: {},
};

const CommonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<Record<string, any>>) => {
      state.userDetails = action.payload;
    },
    setHeader: (state, action: PayloadAction<Record<string, any>>) => {
      state.header = action.payload;
    },
    setLoginToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setPreviousRoute: (state, action: PayloadAction<string>) => {
      state.previousRoute = action.payload;
    },
    setActiveCustomerTab(state, action: PayloadAction<string>) {
      state.activeCustomerTab = action.payload;
    },
    removeAuthToken: (state) => {
      state.token = '';
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      state.userDetails = {};
    },
    // Loading State
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (!action.payload) state.progress = 100; // Set progress to 100 when loading is done
    },
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setWishListCount: (state, action: PayloadAction<number>) => {
      state.wishListCount = action.payload;
    },

    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    setThemeJson: (state, action: PayloadAction<Record<string, any>>) => {
      state.themeJson = action.payload;
    },
    setTemplateImages: (state, action: PayloadAction<Record<string, any>>) => {
      state.templateImages = action.payload;
    },
  },
});

export const {
  setPreviousRoute,
  setLoginToken,
  setUserDetails,
  setIsLoggedIn,
  removeAuthToken,
  setLoading,
  setHeader,
  setProgress,
  setActiveCustomerTab,
  setWishListCount,
  setThemeJson,
  setTemplateImages,
} = CommonSlice.actions;

export default CommonSlice.reducer;
